import { type ReactNode } from 'react'
import { useOutletContext } from 'react-router-dom'

/**
 * Outlet context surfaced to detail-shell pages. Lets the page override
 * the header title once the underlying record has loaded (engagement id,
 * request id, etc.) — the route handle's static title is used as the
 * fallback for the loading state and the document title.
 */
export interface DetailShellOutletContext {
  /** Replace the title rendered in the back-nav header. Pass `null` to revert. */
  setHeaderTitle: (title: string | null) => void
  /** Replace trailing header actions (e.g. messages trigger). Pass `null` to revert. */
  setHeaderActions: (node: ReactNode | null) => void
}

/** Hook for detail-shell pages to override header chrome dynamically. */
export function useDetailHeaderTitle(): DetailShellOutletContext {
  return useOutletContext<DetailShellOutletContext>()
}

/** Alias for pages that set both title and header actions. */
export function useDetailShellHeader(): DetailShellOutletContext {
  return useDetailHeaderTitle()
}
